import type { ComponentProps } from 'react';
import { AgronodLink } from '@agronod/mui-components';
import { Link, type LinkProps } from 'react-router-dom';

// Paketet exporterar inte propstypen – härled den från komponenten.
type AgronodLinkProps = ComponentProps<typeof AgronodLink>;

type Props = Omit<AgronodLinkProps, 'component' | 'href' | 'type'> &
  Pick<LinkProps, 'to'> & { type?: AgronodLinkProps['type'] };

/**
 * Designsystemets länk ovanpå react-router. `AgronodLink` typar bara MUI:s
 * props, så `to` behöver den här tunna varianten för att vara typsäker.
 */
export const RouterLink = ({ type = 'classic', ...props }: Props) => (
  <AgronodLink type={type} component={Link} {...props} />
);
